<template>
  <header class="header-main-top">
    <div class="header-main d-flex justify-content-between align-items-center">
      <div class="d-flex">
        <div
          class="pointer"
          v-if="$route.name != 'PanelDetails' && !isJobRegister"
        >
          <img
            @click="expandSideBar"
            v-if="!menuStatus"
            src="../../assets/img/sidebar/MenuIcon.svg"
            alt=""
          />
          <img
            v-else
            @click="closeSideBar"
            src="../../assets/img/sidebar/MenuActive.svg"
            alt=""
          />
        </div>
        <div class="mx-3">
          <!-- <img src="../../assets/img/h3xlogo.svg" alt="" /> -->
          <img
            src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Logo/SVG/hire3xlogo.svg"
            alt=""
            class="mb-1"
          />
        </div>
        <div
          style="width: auto"
          class="cv-bulders-path d-flex align-items-center ml-2"
          v-if="$route.name != 'PanelDetails'"
        >
          <router-link :to="{ path: `${roleValues.landingPage}` }">
            <h6
              class="m-0 hover-color"
              v-if="roleValues.landingPage == '/vendorlogin'"
            >
              Vendor
            </h6>
            <h6 class="m-0 hover-color" v-else>Recruitment</h6>
          </router-link>
          <div class="d-flex align-items-center mt-1" v-if="display">
            <img class="mr-1" src="../../assets/img/path-forward.svg" alt="" />
            <b-breadcrumb>
              <b-breadcrumb-item
                class="d-flex"
                v-for="(item, index) in levelList"
                :key="item.path"
                :active-class="item.meta.title"
                :active="item.active"
              >
                <div
                  v-b-tooltip.hover.bottomright="
                    item.meta.breadcrumbTitle || item.meta.title
                  "
                  v-if="
                    item.redirect === 'noRedirect' ||
                    index == levelList.length - 1
                  "
                  :class="
                    index > levelList.length - 1
                      ? ''
                      : sharePage && item.meta.title.length > 24
                      ? 'breadcrumb-ellipsis2'
                      : item.meta.title.length > 10
                      ? 'breadcrumb-ellipsis'
                      : ''
                  "
                  class="no-redirect"
                >
                  {{ item.meta.title }}
                </div>
                <div
                  class="breadcrumbs-active-class pointer"
                  v-b-tooltip.hover.bottomright="
                    item.meta.breadcrumbTitle || item.meta.title
                  "
                  :class="
                    index > levelList.length - 2
                      ? ''
                      : sharePage && item.meta.title.length > 24
                      ? 'breadcrumb-ellipsis2'
                      : item.meta.title.length > 10
                      ? 'breadcrumb-ellipsis'
                      : ''
                  "
                  v-else
                  @click.prevent="handleLink(item)"
                >
                  {{ item.meta.title }}
                </div>
              </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-end w-50">
        <div
          style="width: 50%"
          class="position-relative search-bar mr-4"
          v-show="!sharePage"
        >
          <span>
            <img
              class="search-pos"
              src="../../assets/img/search-bar-icon.svg"
              alt=""
            />
          </span>
          <b-form-input
            class="search-input"
            type="search"
            v-model.trim="searchValue"
            @update="textSearch($event)"
            :debounce="600"
            :placeholder="`Search ${searchbar}`"
          ></b-form-input>
          <div
            class="advance-pos"
            v-if="$route.name == 'TalentPool'"
            ref="advance-filter"
            v-closable="{
              exclude: ['advance-filter', 'advance-filter-card'],
              handler: 'closAdvanceFilter',
            }"
          >
            <template class="position-relative">
              <img
                @click="getCustomerFields()"
                class="pointer"
                src="../../assets/talentpool/advancesearch.svg"
                alt=""
              />
              <div
                ref="advance-filter-card"
                v-if="showAdvanceSearch"
                class="advance-search-card"
              >
                <div class="ad-text">Advanced Search</div>
                <!-- Becomes a scroll area only when the rows don't fit the
                     viewport (updateAdvRowsScroll); a scroll container clips
                     the rows' absolutely positioned dropdown menus. -->
                <div
                  ref="advRows"
                  class="mt-3 tp-adv-rows"
                  :class="advRowsScroll ? 'tp-adv-rows-scroll' : ''"
                  :style="
                    advRowsScroll
                      ? { maxHeight: advRowsMaxHeight + 'px' }
                      : null
                  "
                  @click="revealAdvRowPopup($event)"
                >
                  <div
                    class="tp-adv-frow"
                    v-for="(field, index) in advancedFilters"
                    :key="index"
                    :class="index > 0 ? 'mt-3' : ''"
                  >
                    <div class="tp-adv-fcell">
                      <div class="position-relative pointer">
                        <div class="acs-input-head">Field Name</div>
                        <Select
                          id="custom"
                          :dropdownOptions="filterCustomFieldsArray"
                          :showError="false"
                          :disableDropdown="false"
                          :placeholder="'Select Type'"
                          :value="field.key"
                          :text="field.label"
                          @setValue="setFieldKey(index, $event)"
                        />
                      </div>
                    </div>
                    <div class="tp-adv-fcell">
                      <div class="position-relative pointer">
                        <div class="acs-input-head">Operator</div>
                        <Select
                          :type="'filter'"
                          :dropdownOptions="operatorOptions(field)"
                          :showError="false"
                          :disableDropdown="field.key == undefined"
                          :placeholder="'Operator'"
                          :value="field.operator"
                          @setValue="setFieldOperator(index, $event)"
                        />
                      </div>
                    </div>
                    <div class="tp-adv-fcell tp-adv-val">
                      <div class="acs-input-head">Value</div>
                      <div
                        v-if="
                          field.controlType == undefined ||
                          field.controlType == 'text' ||
                          field.controlType == 'email' ||
                          field.controlType == 'number' ||
                          field.controlType == 'rich_text_box'
                        "
                      >
                        <InputField
                          :type="field.controlType"
                          :placeholder="'Search'"
                          :id="field.key"
                          @select-value="setFieldValue(index, $event)"
                          :label="field.label"
                          :noLabel="true"
                          :vmodel="field.value"
                          :disabled="field.controlType == undefined"
                        />
                      </div>

                      <div
                        v-else-if="field.controlType == 'single_select'"
                        class="topDiv"
                      >
                        <SelectCustom
                          :placeholder="field.placeholder"
                          :id="field.key"
                          :api="field.apiEndpoint"
                          :values="field.values"
                          :dropdown="field.dropdown"
                          :fieldType="field.fieldType"
                          @select-value="setFieldValue(index, $event)"
                          :vmodel="field.value"
                          :label="field.label"
                          :noLabel="true"
                        />
                      </div>

                      <div
                        v-else-if="field.controlType == 'static_select'"
                        class="topDiv"
                      >
                        <Select
                          :type="'filter'"
                          :dropdownOptions="field.options"
                          :showError="false"
                          :disableDropdown="false"
                          :value="field.value"
                          :placeholder="field.label"
                          @setValue="setFieldValue(index, $event)"
                        />
                      </div>
                      <div
                        v-else-if="field.controlType == 'static_multi_select'"
                        class="topDiv"
                      >
                        <MultiSelectCustom
                          :placeholder="field.placeholder || field.label"
                          :id="field.key"
                          :values="field.values"
                          :dropdown="true"
                          :fieldType="field.fieldType"
                          @select-value="setFieldValue(index, $event)"
                          :label="field.label"
                          :noLabel="true"
                          :vmodel="field.value"
                        />
                      </div>
                      <div
                        v-else-if="field.controlType == 'source'"
                        class="topDiv"
                      >
                        <Sourcemulti
                          :from="'scroll-filter'"
                          :placeholder="'Select Source'"
                          :vmodel="field.value"
                          :hideVendor="roles.includes('GET_VENDOR_DASHBOARD')"
                          :showThirdParty="false"
                          :noLabel="true"
                          @setValue="setFieldValue(index, $event)"
                        />
                      </div>
                      <div
                        v-else-if="field.controlType == 'addedBy'"
                        class="topDiv"
                      >
                        <AddedByUsers
                          :from="'scroll-filter'"
                          :placeholder="'Select'"
                          :vmodel="field.value"
                          :noLabel="true"
                          @setValue="setFieldValue(index, $event)"
                        />
                      </div>
                      <div
                        v-else-if="field.controlType == 'multi_select'"
                        class="topDiv"
                      >
                        <MultiSelectCustom
                          :mandatory="field.mandatory"
                          :placeholder="field.placeholder"
                          :id="field.key"
                          :api="field.apiEndpoint"
                          :values="field.values"
                          :dropdown="field.dropdown"
                          :fieldType="field.fieldType"
                          @select-value="setFieldValue(index, $event)"
                          :label="field.label"
                          :noLabel="true"
                          :vmodel="field.value"
                        />
                      </div>
                      <div
                        v-else-if="field.controlType == 'multi_text'"
                        class="topDiv"
                      >
                        <FormTags
                          :type="field.controlType"
                          :label="field.label"
                          :noLabel="true"
                          :mandatory="field.mandatory"
                          :placeholder="field.placeholder"
                          :id="field.key"
                          @select-value="setFieldValue(index, $event)"
                          :vmodel="field.value"
                        />
                      </div>
                      <div
                        v-else-if="field.controlType == 'date'"
                        class="topDiv"
                      >
                        <DateField
                          :key="field.key + '-' + (field.operator || 'between')"
                          :format="field.dateTimeFormat"
                          type="date"
                          :vmodel="field.value"
                          :label="field.label"
                          :noLabel="true"
                          :placeholder="field.placeholder"
                          :id="field.key"
                          :range="
                            field.operator == 'between' || !field.operator
                          "
                          @select-value="setFieldValue(index, $event)"
                        />
                      </div>
                      <div
                        v-else-if="field.controlType == 'boolean'"
                        class="topDiv"
                      >
                        <Select
                          :type="'filter'"
                          :dropdownOptions="booleanOptions"
                          :showError="false"
                          :disableDropdown="false"
                          :value="field.value"
                          :placeholder="field.label"
                          @setValue="setFieldValue(index, $event)"
                        />
                      </div>
                    </div>
                    <div class="tp-adv-del-cell">
                      <div class="acs-input-head">&nbsp;</div>
                      <div class="tp-adv-del-inner">
                        <img
                          src="../../assets/img/header/dltAdvanceSearch.svg"
                          :class="
                            advancedFilters.length == 1
                              ? 'disable-opacity'
                              : 'pointer'
                          "
                          @click.stop="
                            advancedFilters.length == 1
                              ? ''
                              : deleteFilter(index)
                          "
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="mt-4 pl-2"
                  :class="
                    filterCustomFieldsArray.length != 0
                      ? 'd-flex align-items-center  justify-content-between'
                      : ''
                  "
                >
                  <div
                    v-if="filterCustomFieldsArray.length != 0"
                    class="pff-btn-txt d-flex align-items-center pointer"
                    @click="addNewField()"
                  >
                    <img
                      class="mr-2"
                      src="../../assets/talentpool/roundAdd.svg"
                      alt=""
                    />Add new Field
                  </div>
                  <div
                    :class="
                      filterCustomFieldsArray.length == 0
                        ? 'd-flex justify-content-end'
                        : ''
                    "
                    class="bluebtn d-flex pr-3"
                  >
                    <b-button
                      class="acs-cancelBtn-modal pointer mr-3"
                      @click="reset()"
                      :disabled="
                        advancedFilters.length == 1 &&
                        advancedFilters[0].key == undefined
                      "
                      >Reset</b-button
                    >
                    <b-button
                      class="acs-cancelBtn-modal pointer mr-3"
                      @click="cancel()"
                      >Cancel</b-button
                    >
                    <b-button
                      class="acs-cancelBtn-modal pointer"
                      @click="search()"
                      >Search</b-button
                    >
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div
            v-if="$route.name == 'TalentPool' && searchApplied"
            class="advance-dot"
          ></div>
        </div>
        <div
          class="mr-4 notificationdd"
          v-if="this.$route.name != 'PanelDetails'"
        >
          <b-dropdown
            right
            ref="notiDropdown"
            no-caret
            variant="link"
            toggle-class="p-0"
            menu-class="notifications-dropdown"
            @show="
              (showAccountsettings = false),
                (isnotiDropdownOpen = true),
                getNotificationDataDetails()
            "
            @hide="isnotiDropdownOpen = false"
          >
            <template #button-content>
              <div
                class="position-relative"
                :class="{
                  'notification-active-class': isnotiDropdownOpen,
                }"
              >
                <img src="../../assets/blueBell.svg" alt="" />

                <div
                  :class="
                    totalUnreadCount < 10
                      ? 'r0'
                      : totalUnreadCount >= 10 && totalUnreadCount <= 99
                      ? 'rightn7px'
                      : 'rightn12px'
                  "
                  class="
                    notification-count-tag
                    fw-600
                    fs-10
                    color-white
                    font-mont
                  "
                >
                  {{ totalUnreadCount > 99 ? "99+" : totalUnreadCount }}
                </div>
              </div>
            </template>

            <div
              class="
                dropdown-header
                d-flex
                justify-content-between
                align-items-center
              "
            >
              <strong class="fs-16 font-mont color-344054 fw-600"
                >Notifications</strong
              >
              <div
                class="
                  fs-12
                  font-lato
                  fw-500
                  color-mainblue
                  pointer
                  text-underline
                "
                @click="marknotificationAsRead"
                v-if="notifications.length !== 0"
              >
                Mark all as read
              </div>
            </div>
            <section
              style="max-height: 450px"
              class="overflow-auto"
              @scroll="onScroll"
            >
              <div
                class="
                  d-flex
                  flex-column
                  align-items-center
                  justify-content-center
                  h-100
                  my-5
                "
                v-if="!isLoading && notifications.length === 0"
              >
                <img src="@/assets/img/header/emptynotification.svg" alt="" />
                <h6 class="color-7a7a7a font-lato fw-600 fs-14 mt-2 mb-0">
                  You don’t have any notifications
                </h6>
              </div>
              <div
                v-else-if="isLoading && notifications.length === 0"
                class="px-3 mt-2"
              >
                <b-skeleton
                  v-for="i in 5"
                  :key="i"
                  height="60px"
                  width="100%"
                  class="mb-3"
                />
              </div>
              <template v-else>
                <section
                  v-for="(groupItems, groupName) in groupedNotifications"
                  :key="groupName"
                  class="w-100 px-3 my-2"
                >
                  <!-- Group Title -->
                  <div class="fw-600 fs-12 font-lato color-7a7a7a mb-1">
                    {{ groupName }}
                  </div>

                  <!-- Loop through each notification in the group -->
                  <div
                    v-for="(item, index) in groupItems"
                    :key="index + '-' + groupName"
                    class="w-100"
                  >
                    <div
                      :class="{
                        unread: item.read == false,
                        'align-items-center': item.event && item.event.link,
                      }"
                      class="
                        notiitems
                        d-flex
                        w-100
                        px-2
                        py-1
                        justify-content-between
                        mt-1
                      "
                    >
                      <div
                        v-html="item.message"
                        class="w-80 fs-14 fw-500 fam-lato color-3a3c40"
                      ></div>

                      <div
                        class="
                          fs-10
                          fw-LM
                          color-7a7a7a
                          font-italic
                          fam-lato
                          d-flex
                          justify-content-end
                          flex-column
                          align-items-end
                        "
                      >
                        <!-- -->
                        <div
                          class="
                            d-flex
                            align-items-center
                            gap10px
                            position-relative
                          "
                          ref="excludeCard"
                          v-closeArray="{
                            index,
                            property: 'activeDropdownIndex',
                            array: groupItems,
                            handler: () => closenotidd(groupName, index),
                            exclude: ['notithreedots', 'excludeCard'],
                          }"
                        >
                          <img
                            src="@/assets/img/header/rightarrow.svg"
                            alt=""
                            @click.stop="goToEventLink(item.event)"
                            class="pointer"
                            v-if="item.event && item.event.link"
                          />
                          <img
                            src="@/assets/img/header/threedots.svg"
                            alt=""
                            class="pointer"
                            @click="togglemarkasreadDropdown(groupName, index)"
                            ref="notithreedots"
                          />
                          <div
                            @click="makeasReadandUnread(item)"
                            class="
                              notification-markasread-dd
                              pointer
                              d-flex
                              align-items-center
                              pl-3
                            "
                            v-if="item.activeDropdownIndex == true"
                            ref="notimarkdd"
                          >
                            <span
                              v-if="item.read"
                              class="
                                fs-13
                                fw-500
                                color-3a3c40
                                font-lato font-normal
                              "
                            >
                              Mark as unread
                            </span>
                            <span
                              v-else
                              class="
                                fs-13
                                fw-500
                                color-3a3c40
                                font-lato font-normal
                              "
                            >
                              Mark as read
                            </span>
                          </div>
                        </div>
                        {{ item.dateTimeText }}
                      </div>
                    </div>

                    <hr
                      class="my-2 notification-hr"
                      v-if="index !== groupItems.length - 1"
                    />
                  </div>
                </section>
              </template>

              <!-- Loader -->
              <div
                style="margin: auto"
                class="d-flex justify-content-center mb-3"
                v-if="showLoader"
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </section>
          </b-dropdown>
        </div>

        <!-- switch apps -->
        <div
          class="position-relative mr-2"
          v-if="count > 1 && $route.name != 'PanelDetails'"
        >
          <div
            class="sp-active-main-container pointer"
            @click="showswitch = !showswitch"
            ref="switch"
          >
            <img src="../../assets/switchapps/grid.svg" alt="" />
            <img
              v-show="!showswitch"
              src="../../assets/switchapps/chevron-down.svg"
              class="ml-2"
              alt=""
            />
            <img
              v-show="showswitch"
              src="../../assets/switchapps/chevron-up.svg"
              class="ml-2"
              alt=""
            />
          </div>
          <div
            class="allproj-dropdown"
            v-if="showswitch"
            ref="switch-body"
            v-closable="{
              exclude: ['switch-body', 'switch'],
              handler: 'closeSwitch',
            }"
          >
            <div class="allproj-card" v-if="accessCandidate" @click="openCan">
              <img src="../../assets/All-projects-icons/cand.svg" alt="" />

              <div class="allproj-card-head">Candidates</div>

              <div class="allproj-card-subhead">
                Login to resume builder, much more
              </div>
            </div>

            <div
              class="allproj-card"
              v-if="accessAssessment"
              @click="openAssess"
            >
              <img src="../../assets/All-projects-icons/assess.svg" alt="" />

              <div class="allproj-card-head">Assessment</div>

              <div class="allproj-card-subhead">
                Create, manage assessment progress
              </div>
            </div>
            <div class="allproj-card allproj-card-selected">
              <img src="../../assets/All-projects-icons/rec.svg" alt="" />

              <div class="allproj-card-head">Recruiters</div>

              <div class="allproj-card-subhead">
                Build & hire from our network, AI features
              </div>
            </div>
            <div
              class="allproj-card"
              v-if="accessTraining"
              @click="openTraining"
            >
              <img src="../../assets/All-projects-icons/training.svg" alt="" />

              <div class="allproj-card-head">Training</div>

              <div class="allproj-card-subhead">
                Create, manage & edit course videos
              </div>
            </div>
          </div>
        </div>

        <div class="login-details position-relative pointer">
          <div class="d-flex align-items-center">
            <!-- <div
            class="profile-details d-flex align-items-center text-capitalize"
          >
            <h6 class="m-0" v-if="roleValues.username">
              {{ roleValues.username }}
            </h6>
            <h6 class="m-0" v-else>{{ extPanel }}</h6>
          </div>
          <div v-b-hover="handleHover" class="mr-2 pointer">
            <img src="../../assets/defaultdp.svg" alt="" />
            <img
              v-if="!showdpcard"
              class="ml-1"
              src="../../assets/img/header/downarrow.svg"
              alt=""
            />
            <img
              v-else
              class="ml-1"
              src="../../assets/img/header/uparrow.svg"
              alt=""
            />
          </div> -->
            <div
              @click="showAccountsettings = !showAccountsettings"
              :class="
                showAccountsettings
                  ? 'profilepic-border-active'
                  : 'profilepic-border'
              "
              ref="profile-image"
            >
              <!-- class="header-profile-pic" -->
              <img
                :src="profileIcon ? profileIcon : userInfo.profileImage"
                alt=""
                class="br-50 h-100 w-100 pointer"
              />
            </div>
            <div
              v-if="showAccountsettings"
              v-closable="{
                exclude: ['profile-image'],
                handler: 'closeAccountsetting',
              }"
            >
              <div class="tnt-new-sortcard p-2 mt-2">
                <div class="d-flex align-items-center profile-container w-100">
                  <div style="width: 14%">
                    <div class="d-flex">
                      <div class="profile-container-img">
                        <img
                          style="border-radius: 50%"
                          class="h-100 w-100"
                          :src="
                            profileIcon ? profileIcon : userInfo.profileImage
                          "
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    :class="
                      roleValues.username && roleValues.username.length > 20
                        ? 'text-truncate'
                        : ''
                    "
                    style="width: 86%; word-break: break-all"
                    class="profile-container-font ml-2"
                  >
                    <span v-if="roleValues.username">
                      {{ roleValues.username }}</span
                    >
                    <span v-else> {{ extPanel }}</span>
                  </div>
                </div>

                <div
                  class="d-flex align-items-center mt-2 p-1 pointer hoverclass"
                  v-if="this.$route.name != 'PanelDetails'"
                  @click="
                    $router.push({
                      name: 'Profile',
                    })
                  "
                >
                  <div style="margin-right: 11px">
                    <img
                      class="h-100 w-100"
                      src="../../assets/New Profile/Settings.svg"
                      alt=""
                    />
                  </div>
                  <div class="profile-container-subhead">Account Settings</div>
                </div>
                <div
                  class="d-flex align-items-center mt-2 p-1 pointer hoverclass"
                  v-if="
                    this.$route.name != 'PanelDetails' &&
                    roles.includes('HIRE3X_WALLET')
                  "
                  @click="goToCredits()"
                >
                  <div class="mr-2 ml-1">
                    <img
                      class="h-100 w-100"
                      src="../../assets/New Profile/bills.svg"
                      alt=""
                    />
                  </div>
                  <div class="profile-container-subhead">Hire3x Wallet</div>
                </div>

                <div class="new-profile-line mt-2"></div>

                <div
                  class="
                    d-flex
                    align-items-center
                    justify-content-center
                    pointer
                    p-1
                    hoverclass
                  "
                  @click="logout()"
                >
                  <div class="mr-1">
                    <img
                      class="h-100 w-100"
                      src="../../assets/New Profile/Logout.svg"
                      alt=""
                    />
                  </div>
                  <div class="sign-out-font">Sign Out</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="d-flex align-items-center">
          <div class="profile-details d-flex align-items-center">
            <span class="mr-1">Welcome, </span>
            <h6 class="m-0">Mark Philip</h6>
          </div>
          <div>
            <img src="../../assets/img/login-logo.svg" alt="" />
          </div>
        </div>  -->
      </div>

      <!-- <div
        class="position-relative d-flex align-items-center ml-2"
        v-if="!isJobRegister"
      >
       

        <div
          
          class="login-det-container d-flex align-items-center pointer"
        > -->
      <!-- <div
          v-if="external"
          class="
            login-det-container
            d-flex
            align-items-center
            justify-content-center
            p-2
            pointer
          "
          @click="logout"
        >
          <img src="../../assets/img/header/logout.svg" alt="" />
          <span class="ml-2 logout-txt">LOG OUT</span>
        </div>
        </div>
        <div
          v-else
          class="login-det-container d-flex align-items-center pointer"
          @click="showdpcard = !showdpcard"
          ref="log-label"
          v-closable="{
            exclude: ['log-label'],
            handler: 'closeLog',
          }"
        >
          <div>
            <img src="../../assets/img/header/defaultprofilepic.svg" alt="" />
          </div>
          <div class="d-flex align-items-center text-capitalize ml-1">
            <span class="welcometext">Welcome,</span> &nbsp;
            <span class="username"> {{ roleValues.username }}</span>
          </div>
        </div>
        <div class="logoutbox mt-2 pointer" v-if="showdpcard">
          <div
            v-if="!external"
            class="dropdown-head dropdown-sub p-2"
            @click="
              $router.push({
                name: 'Profile',
              })
            "
          >
            My Profile
          </div>

          <div
            class="d-flex align-items-center justify-content-center p-2"
            @click="logout"
          >
            <img src="../../assets/img/header/logout.svg" alt="" />
            <span class="ml-2 logout-txt">LOG OUT</span>
          </div>

          
          <b-popover
            triggers="click"
            target="switch-app"
            id="switchapp-popover"
          >
            <div style="width: 205px">
              <div class="p-2 dropdown-active">Recruitment</div>
              <div
                class="p-2"
                :class="
                  accessAssessment
                    ? 'dropdown-options pointer'
                    : 'disable-dropdown-options'
                "
                @click="openAssess"
              >
                Assessment
              </div>
              <div
                class="p-2"
                :class="
                  accessTraining
                    ? 'dropdown-options pointer'
                    : 'disable-dropdown-options'
                "
              >
                Training
              </div>
              <div
                class="p-2"
                :class="
                  accessCandidate
                    ? 'dropdown-options pointer'
                    : 'disable-dropdown-options'
                "
                @click="openCan"
              >
                Candidate
              </div>
            </div>
          </b-popover> 
        </div> 
      </div>-->
    </div>
    <b-modal
      id="preferencemodal"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
    >
      <div class="prefmodalheading d-flex align-items-center">
        Preference settings
      </div>
      <div class="mt-1 prefmodal-subhead">
        Let us know where we need to direct you once you login.You can later
        change this preference in settings.
      </div>
      <div class="prefmodal-radios mt-3">
        <b-form-radio
          v-if="accessRecruitment"
          v-model="selected"
          value="recruitment"
          >Recruitment</b-form-radio
        >
        <b-form-radio
          v-if="accessAssessment"
          v-model="selected"
          value="assessment"
          >Assessment</b-form-radio
        >
        <b-form-radio v-if="accessTraining" v-model="selected" value="training"
          >Training</b-form-radio
        >
        <b-form-radio
          v-if="accessCandidate"
          v-model="selected"
          value="candidate"
          >Candidate</b-form-radio
        >
      </div>
      <hr
        style="
          border-bottom: 1px solid rgba(128, 128, 128, 0.2);
          margin-top: 10px;
        "
      />
      <div class="prefmodal-checkbox">
        <b-form-checkbox id="checkbox-1" v-model="status">
          Don’t show me this message again.
        </b-form-checkbox>
      </div>
      <div
        class="
          mt-4
          d-flex
          align-items-center
          justify-content-end
          prefmodal-btns
        "
      >
        <b-button variant="light" @click="closeval()">Cancel</b-button>
        <b-button variant="primary ml-2" @click="setPref()">Apply</b-button>
      </div>
    </b-modal>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
// import compile from 'path-to-regexp'
import { postPreference, getPreference } from "../../utils/apiFunctions";
import successModal from "../../components/mixin/toast";
import {
  getShowPreference,
  setShowPreference,
  checkExternalPanelist,
} from "../../utils/tokenCheck";
import { LogoutMixins } from "../../views/login/LogoutMixins";
import Select from "../../components/fixedcomponents/Select.vue";
import InputField from "../../components/InputComponents/Input.vue";
import DateField from "../../components/InputComponents/DateField.vue";
import SelectCustom from "../../components/InputComponents/SelectCustom.vue";
import MultiSelectCustom from "../../components/InputComponents/MultiSelectCustom.vue";
import Sourcemulti from "../../components/fixedcomponents/TalentPool/Source.vue";
import AddedByUsers from "../../components/fixedcomponents/TalentPool/AddedByUsers.vue";
import EventBus from "../../utils/eventBus.js";
import { fieldDisplayLabel } from "../../utils/customFields";
import {
  getCustomerFields,
  getNotificationData,
  markasReadNotification,
  markasReadandUnreadNotification,
} from "../../utils/apiFunctions";
import FormTags from "../../components/InputComponents/FormTags";
import { getLoggedInUserEmail } from "../../utils/request";
import errorModal from "../../components/mixin/toast";
const { compile } = require("path-to-regexp");

export default {
  name: "Header",
  mixins: [LogoutMixins, successModal, errorModal],
  data() {
    return {
      isnotiDropdownOpen: false,
      profileIcon: "",
      loopvar: 10,
      showAdvanceSearch: false,
      adfieldname: true,
      route: "",
      selected: null,
      display: true,
      showdpcard: false,
      showswitch: false,
      levelList: null,
      searchbar: "Customers",
      sharePage: false,
      status: false,
      searchValue: "",
      currentComponentName: "",
      currentComponentTitle: "",
      currentCvSearch: "",
      jobID: null,
      customerName: null,
      jobIDKanban: "",
      customerNameKanban: "",
      customerId: "",
      currentTitle: "",
      count: 1,
      preferences: {},
      accessRecruitment: true,
      accessTraining: false,
      accessCandidate: false,
      accessAssessment: false,
      dontAskMeAgain: false,
      isLaptop: true,
      external: false,
      totalUnreadCount: 0,
      searchApplied: false,
      filterType: {
        value: "",
        text: "",
      },
      options: [
        { text: "Radio 1", value: "radio1" },
        { text: "Radio 3", value: "radio2" },
        { text: "Radio 2", value: "radio3" },
        { text: "Radio 4", value: "radio4" },
      ],
      advancedFilters: [
        {
          value: "",
        },
      ],
      storeFilter: [
        {
          value: "",
        },
      ],
      filterCustomFieldsArray: [],
      // Candidate form config for Advanced Search, fetched once and reused
      // (see loadAdvancedSearchFields).
      advFormFields: null,
      advFormFieldsRequest: null,
      // Advanced-search rows: scroll only when they overflow the viewport.
      advRowsScroll: false,
      advRowsMaxHeight: 0,
      notifications: [],
      showLoader: false,
      total: null,
      pageEnd: null,
      page: 0,
      isLoading: false,
      activeNotificationID: null,
      showAccountsettings: false,
    };
  },
  computed: {
    // Static Yes/No choices for boolean custom fields in advanced search.
    booleanOptions() {
      return [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ];
    },
    groupedNotifications() {
      const grouped = {};
      this.notifications.forEach((item) => {
        const group = item.daysText || "Others";
        if (!grouped[group]) grouped[group] = [];
        grouped[group].push(item);
      });

      return grouped;
    },
    ...mapGetters("userVUEX", {
      getShowPref: "getShowPref",
      loggedin: "checkLoginStatus",
      roleValues: "getRoleValues",
      menuStatus: "getMenuStatus",
      extPanel: "getLoggedInUserEmail",
      userInfo: "getUserDetail",
    }),
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
    ...mapGetters("vendorVUEX", {
      vendorValue: "changeValue",
    }),
    ...mapGetters("accessControlVUEX", {
      searchTab: "getSearchTab",
    }),
    isJobRegister() {
      return (
        this.$route.name === "JobRegistration" ||
        this.$route.name === "FareWellPage"
      );
    },
    ...mapGetters({ roles: "roles" }),
    switchBreadcrumbs() {
      let matched = this.$route.matched.filter((item) => item.meta?.title);
      switch (this.$route.name) {
        case "Documents":
          matched.splice(
            0,
            0,
            {
              name: "Documents",
            },
            {
              name: "Documents",
              meta: {
                redirect: "noRedirect",
                title: "Documents",
              },
            }
          );
          return matched;
        case "JobDashboard":
          matched.splice(
            0,
            0,
            {
              name: "Job Dashboard",
            },
            {
              name: "JobDashboard",
              query: {
                status: this.$route.query.status,
              },
              meta: {
                redirect: "noRedirect",
                title: "Job Dashboard",
              },
            },
            {
              redirect: "noRedirect",
              meta: {
                title:
                  this.$route.query.status === "recruiterview"
                    ? "Allocated Recruiters"
                    : "Assigned Jobs",
              },
            }
          );
          return matched;
        case "InternalHiringDashboard":
          matched.splice(
            0,
            1,
            {
              name: "workBench",
              query: {
                type: this.$route.query.type,
                sort: this.$route.query.sort,
              },
              meta: { title: "Customers" },
            },
            {
              redirect: "noRedirect",
              meta: {
                title: "...",
                breadcrumbTitle:
                  this.$route.query.cardName || this.$route.params.cardName,
              },
            },
            {
              redirect: "noRedirect",
              meta: {
                title: "Jobs",
              },
            }
          );
          return matched;
        case "jobs":
          matched.splice(
            0,
            1,
            {
              name: "clientdashboard",
              meta: {
                title: "Clients",
              },
            },
            {
              redirect: "noRedirect",
              meta: {
                title: this.$route.query.clientName,
              },
            }
          );
          return matched;
        case "CreateJob":
          matched.splice(
            0,
            1,
            {
              name: "workBench",
              query: {
                type: this.$route.query.type,
                sort: this.$route.query.sort,
              },
              meta: { title: "Customers" },
            },
            {
              name: "InternalHiringDashboard",
              meta: {
                title: "...",
                breadcrumbTitle: this.$route.query.customerName + " Jobs",
              },
              query: {
                cardName: this.$route.query.customerName,
              },
            },
            {
              meta: {
                title:
                  this.$route.query.type === "Create"
                    ? "Create Job"
                    : this.$route.query.type === "Activate"
                    ? "Activate Job"
                    : this.$route.query.type === "Re-Open"
                    ? "Re-Open Job"
                    : "Edit Job",
                breadcrumbTitle: this.$route.query.customerName + " Job's",
              },
            }
          );
          return matched;
        case "cvSearchKanban":
        case "cvSearchTalentPool":
          matched.splice(
            0,
            2,
            {
              name: this.getDynamicName(this.$route),
              meta: { title: this.getDynamicTitle(this.$route) },
              query: {
                customerID: this.$route.query.customerID,
                jobID: this.$route.query.jobID,
                cardName: this.$route.query.cardName,
              },
            },
            {
              redirect: "noRedirect",
              meta: {
                title: "CV Search",
              },
            }
          );
          return matched;

        case "CreateJobs":
        case "EditJobs":
          matched.splice(
            0,
            0,
            {
              name: "workBench",
              meta: { title: "Workbench" },
              query: {
                type: this.$route.query.type,
                sort: this.$route.query.sort,
              },
            },
            {
              name: "InternalHiringDashboard",
              params: {
                cardName: this.$route.query.cardName,
                customerID: this.$route.query.customerID,
              },
              query: {
                itype: this.$route.query.itype,
                isort: this.$route.query.isort,
                type: this.$route.query.type,
                sort: this.$route.query.sort,
              },
              meta: { title: this.$route.query.cardName },
            }
          );
          return matched;
        case "HiringProcessDashboard":
          matched.splice(
            0,
            0,
            {
              name: "Hiring",
            },
            {
              status: this.$route.query.status,
              name: "HiringProcessDashboard",
              meta: { title: "Hiring Process" },
            }
          );
          return matched;
        case "JdDetails":
          matched.splice(
            0,
            0,
            {
              name: "workBench",
              query: {
                type: this.$route.query.type,
                sort: this.$route.query.sort,
              },
              meta: { title: "Workbench" },
            },
            {
              path: `board/${this.$route.query.cardName}/${this.$route.query.customerID}`,
              query: {
                itype: this.$route.query.itype,
                isort: this.$route.query.isort,
                type: this.$route.query.type,
                sort: this.$route.query.sort,
              },
              meta: {
                title: "...",
                breadcrumbTitle: this.$route.query.cardName,
              },
            },
            {
              redirect: "noRedirect",
              meta: {
                title: this.$route.query.jobTitle,
              },
            }
          );
          return matched;
        case "Analytics":
        case "OnboardingDocuments":
          matched.splice(
            0,
            2,
            {
              name: "workBench",
              meta: { title: "Customers" },
              query: {
                type: this.$route.query.type,
                sort: this.$route.query.sort,
              },
            },
            {
              path: `/jobs/board/${this.$route.query.cardName}/${this.$route.query.customerID}`,
              query: {
                itype: this.$route.query.itype,
                isort: this.$route.query.isort,
                type: this.$route.query.type,
                sort: this.$route.query.sort,
                cardName:
                  this.$route.query.cardName || this.$route.query.customerName,
              },
              meta: {
                title: "...",
                breadcrumbTitle:
                  (this.$route.query.cardName ||
                    this.$route.query.customerName) + " Jobs",
              },
            },
            {
              name: "Kanban",
              meta: {
                title: "Kanban",
              },
              query: {
                jobID: this.$route.query.jobID,
                cardName: this.$route.query.customerName,
                customerID: this.$route.query.customerID,
              },
            },
            {
              redirect: "noRedirect",
              meta: {
                title: this.getComponentTitle(this.$route),
              },
            }
          );
          if (!this.roles.includes("GET_JOBDASHBOARD"))
            return matched.filter((_, index) => index !== 2);
          else return matched;

        case "Kanban":
        case "ApplicationTable":
          matched.splice(
            0,
            2,
            {
              name: "workBench",
              meta: { title: "Customers" },
              query: {
                type: this.$route.query.type,
                sort: this.$route.query.sort,
              },
            },
            {
              path: `/jobs/board/${this.$route.query.cardName}/${this.$route.query.customerID}`,
              query: {
                itype: this.$route.query.itype,
                isort: this.$route.query.isort,
                type: this.$route.query.type,
                sort: this.$route.query.sort,
                cardName:
                  this.$route.query.cardName || this.$route.query.customerName,
              },
              meta: {
                title: "...",
                breadcrumbTitle:
                  (this.$route.query.cardName ||
                    this.$route.query.customerName) + " Jobs",
              },
            },
            {
              redirect: "noRedirect",
              name: "Kanban",
              meta: {
                title: this.getComponentTitle(this.$route),
              },
            }
          );
          return matched;
        case "AddCandidateInVendor":
          matched.splice(
            0,
            1,
            {
              name: "clientdashboard",
              meta: {
                title: "Clients",
              },
            },
            {
              name: "jobs",
              meta: {
                title: this.$route.query.clientName,
              },
              params: {
                vendorID: this.$route.query.vendorID,
                client: this.$route.query.clientName,
              },
              query: {
                clientName: this.$route.query.clientName,
              },
            },
            {
              name: "VendorKanban",
              meta: {
                title: "...",
                breadcrumbTitle: this.$route.query.jobTitle,
              },
              params: {
                vendorID: this.$route.query.vendorID,
                client: this.$route.query.clientName,
              },
              query: {
                clientName: this.$route.query.clientName,
                jobTitle: this.$route.query.jobTitle,
                jobID: this.$route.query.jobID,
              },
            }
          );
          return matched;
        case "VendorKanban":
          matched.splice(
            0,
            1,
            {
              name: "clientdashboard",
              meta: {
                title: "Clients",
              },
            },
            {
              name: "jobs",
              meta: {
                title: this.$route.query.clientName,
              },
              query: {
                clientName: this.$route.query.clientName,
              },
            },
            {
              redirect: "noRedirect",
              meta: {
                title: this.$route.query.jobTitle,
              },
              query: {
                clientName: this.$route.query.clientName,
              },
            }
          );
          return matched;
        case "ApplicationPreview":
          matched.splice(
            0,
            0,
            {
              name: "workBench",
              meta: { title: "Workbench" },
              query: {
                type: this.$route.query.type,
                sort: this.$route.query.sort,
              },
            },
            {
              path: `/jobs/jddetails`,
              query: {
                jobID: this.$route.query.jobID,
                jobTitle: this.$route.query.jobTitle,
                customerID: this.$route.query.customerID,
                cardName: this.$route.query.cardName,
                itype: this.$route.query.itype,
                isort: this.$route.query.isort,
                type: this.$route.query.type,
                sort: this.$route.query.sort,
                status: this.$route.query.status,
              },
              meta: {
                title: "...",
                breadcrumbTitle: this.$route.query.jobTitle,
              },
            },
            {
              name: "ApplicationTable",
              meta: { title: "Applications" },
              query: {
                cardName: this.$route.query.cardName,
                jobTitle: this.$route.query.jobTitle,
                jobID: this.$route.query.jobID,
                customerID: this.$route.query.customerID,
                status: this.$route.query.status,
                itype: this.$route.query.itype,
                isort: this.$route.query.isort,
                type: this.$route.query.type,
                sort: this.$route.query.sort,
                appstatus: this.$route.query.appstatus,
              },
            }
          );
          return matched;
        case "AddCandidateInJD":
        case "EditCandidateInJD":
        case "viewRequiredCandidateDocs":
          if (this.$route.query.from == "VendorKanban") {
            matched.splice(
              0,
              0,
              {
                name: "clientdashboard",
                meta: {
                  title: "Clients",
                },
              },
              {
                name: "VendorKanban",
                meta: { title: "Kanban" },
                params: {
                  vendorID: this.$route.query.vendorID,
                  client: this.$route.query.client,
                },
                query: {
                  clientName: this.$route.query.clientName,
                  jobTitle: this.$route.query.jobTitle,
                  jobID: this.$route.query.jobID,
                  vendorID: this.$route.query.vendorID,
                },
              }
            );
          } else if (this.$route.query.from == "TalentPool") {
            matched.splice(0, 0, {
              name: "TalentPool",
              meta: { title: "TalentPool" },
            });
          } else {
            matched.splice(
              0,
              0,
              {
                name: "workBench",
                meta: { title: "Customers" },
              },
              {
                name: "InternalHiringDashboard",
                meta: {
                  title: "...",
                  breadcrumbTitle: this.$route.query.cardName + "Jobs",
                },
                query: {
                  cardName:
                    this.$route.query.customerName ||
                    this.$route.query.cardName,
                },
              },
              {
                name: "Kanban",
                // path: `/jobs/board/${this.$route.query.cardName}/${this.$route.query.customerID}`,
                query: {
                  type: this.$route.query.type,
                  sort: this.$route.query.sort,
                  customerID: this.$route.query.customerID,
                  jobID: this.$route.query.jobID,
                  cardName:
                    this.$route.query.customerName ||
                    this.$route.query.cardName,
                },
                meta: {
                  title: "Kanban",
                },
              },
              {
                path: `/jobs/jddetails`,
                query: {
                  jobID: this.$route.query.jobID,
                  jobTitle: this.$route.query.jobTitle,
                  customerID: this.$route.query.customerID,
                  cardName: this.$route.query.cardName,
                  status: this.$route.query.status,
                  itype: this.$route.query.itype,
                  isort: this.$route.query.isort,
                  type: this.$route.query.type,
                  sort: this.$route.query.sort,
                },
                meta: { title: this.$route.query.jobTitle },
              }
            );
          }
          return matched;
        case "ReviewCandidates":
          matched.splice(
            0,
            2,
            {
              redirect: "noRedirect",
              meta: { title: "Approval" },
            },
            {
              redirect: "noRedirect",
              meta: { title: "Candidate Approval" },
            }
          );
          return matched;
        case "ViewJds":
          matched.splice(
            0,
            2,
            {
              redirect: "noRedirect",
              meta: { title: "Approval" },
            },
            {
              redirect: "noRedirect",
              meta: { title: "Job Approval" },
            }
          );
          return matched;
        case "ReviewJds":
          matched.splice(
            0,
            2,
            {
              name: "ViewJds",
              query: {
                status: this.$route.query.status,
              },
              meta: {
                title: "Review Jobs",
              },
            },
            {
              redirect: "noRedirect",
              meta: { title: this.$route.query.title },
            }
          );
          return matched;
        case "ViewCandidateStatus":
          matched.splice(
            0,
            0,
            {
              name: "ReviewCandidates",
              query: {
                status: this.$route.query.status,
              },
              meta: {
                title: "Review Candidates",
              },
            },
            {
              redirect: "noRedirect",
              meta: { title: "...", breadcrumbTitle: this.$route.query.name },
            }
          );
          return matched;
        case "vendorCandidates":
          matched.splice(
            0,
            2,
            {
              path: "/vendorlogin",
              meta: {
                title: "Home",
              },
              query: {
                sort: this.$route.query.sort,
              },
            },
            {
              redirect: "noRedirect",
              meta: { title: this.$route.params.title },
            }
          );
          return matched;
        case "AddCandidateInVendor || EditCandidateInVendor":
          matched.splice(
            0,
            0,
            {
              path: "/vendorlogin",
              meta: { title: "Assign Jobs" },
              query: {
                sort: this.$route.query.sort,
              },
            },
            {
              name: "vendorCandidates",
              params: {
                jobID: this.$route.query.jobID,
                customerID: this.$route.query.customerID,
                title: this.$route.query.title,
              },
              meta: { title: this.$route.query.title },
            }
          );
          return matched;
        case "customtable":
          matched.splice(
            0,
            2,
            {
              name: "customform",
              meta: { title: "Custom Field" },
              query: {
                id: this.$route.query.id,
              },
            },
            {
              name: "customtable",
              meta: { title: this.$route.query.heading },
            }
          );
          return matched;

        case "Manage":
        case "AddVendor":
        case "AddCustomer":
        case "ActivateCustomer":
        case "ActivateVendor":
        case "EditCustomer":
        case "EditVendor":
          matched.splice(0, 0, {
            name: "Manage",
            meta: { title: "Manage" },
            query: {
              status: this.$route.query.status,
              type: this.$route.query.type,
              sort: this.$route.query.sort,
              // customerType:this.$route.query.customerType,
            },
          });
          return matched;
        case "InterviewProcessDashboard":
        case "CreateInterviewProcess":
        case "EditInterviewProcess":
        case "ActivateInterview":
          matched.splice(0, 0, {
            name: "HiringProcessDashboard",
            meta: { title: "Hiring Process" },
            query: {
              status: this.$route.params.status_i || this.$route.query.status,
              type: this.$route.query.type,
              sort: this.$route.query.sort,
            },
          });
          return matched;

        case "ViewInterviewProcess":
          if (
            this.$route.query.status == "edit" ||
            this.$route.query.status == "viewInterview"
          ) {
            matched.splice(
              0,
              2,
              {
                name: "HiringProcessDashboard",
                meta: { title: "Hiring Process" },
                query: {
                  type: this.$route.query.type,
                  sort: this.$route.query.sort,
                },
              },
              {
                meta: { title: "Edit Interview Process" },
                query: {
                  type: this.$route.query.type,
                  sort: this.$route.query.sort,
                },
              }
            );
          } else {
            matched.splice(0, 0, {
              name: "InterviewProcessDashboard",
              meta: { title: "Hiring Process" },
              query: {
                type: this.$route.query.type,
                sort: this.$route.query.sort,
              },
            });
          }
          return matched;
        case "PreviewFeedbackform Dashboard":
        case "Feedbackform Dashboard":
        case "ActivateFeedbackForm":
          matched.splice(0, 0, {
            name: "HiringProcessDashboard",
            meta: { title: "Hiring Process" },
            query: {
              status: "feedbackForm",
              type: this.$route.query.type,
              sort: this.$route.query.sort,
            },
          });
          return matched;
        case "SelectedCandidates":
        case "RejectedCandidates":
        case "SendAppointment":
        case "OnboardingCandidates":
          matched.splice(0, 0, {
            name: "Dashboard",
            meta: { title: "HR Portal" },
            query: {
              status: this.$route.query.status,
            },
          });
          return matched;
        case "OfferLetter":
          matched.splice(
            0,
            0,
            {
              name: "Dashboard",
              meta: { title: "HR Portal" },
              query: {
                status: this.$route.query.status,
              },
            },
            {
              name: "SelectedCandidates",
              meta: { title: "Selected Candidates" },
            }
          );
          return matched;
        case "TemplatesOfferLetter":
          matched.splice(
            0,
            0,
            {
              name: "Dashboard",
              meta: { title: "HR Portal" },
              query: {
                status: this.$route.query.status,
              },
            },
            {
              name: "SelectedCandidates",
              meta: {
                title: "...",
                breadcrumbTitle: "Selected Candidates",
              },
            },
            {
              name: "OfferLetter",
              params: {
                candidateID: this.$route.params.candidateID,
              },
              query: {
                redirect: this.$route.query.redirect,
              },
              meta: { title: "Offer Letter" },
            }
          );
          return matched;
        case "CandidateDetails":
        case "EditOfferLetter":
          matched.splice(
            0,
            0,
            {
              name: "Dashboard",
              meta: { title: "HR Portal" },
              query: {
                status: this.$route.query.status,
              },
            },
            {
              name: this.$route.query.redirect,
              meta: {
                title: this.$route.query.redirect.replace(/([A-Z])/g, " $&"),
              },
              query: {
                status: this.$route.query.status,
              },
            }
          );
          return matched;
        case "AppointmentLetter":
          matched.splice(
            0,
            0,
            {
              name: "Dashboard",
              meta: { title: "HR Portal" },
              query: {
                status: this.$route.query.status,
              },
            },
            {
              name: "SendAppointment",
              meta: { title: "Send Appointment" },
            }
          );
          return matched;
        case "ViewOnboardingCandidate":
          matched.splice(
            0,
            0,
            {
              name: "Dashboard",
              meta: { title: "HR Portal" },
              query: {
                status: this.$route.query.status,
              },
            },
            {
              name: "OnboardingCandidates",
              meta: { title: "Offer Accepted" },
            }
          );
          return matched;
        case "ViewCandidateProfile":
          if (this.$route.params.componentName == "Bookmarked") {
            matched.splice(
              0,
              0,
              {
                name: this.currentComponentName,
                meta: { title: this.currentComponentTitle },
                query: {
                  jobID: this.jobIDKanban,
                  cardName: this.customerNameKanban,
                  customerID: this.customerId,
                },
              },
              {
                name: this.currentCvSearch,
                meta: { title: "CV Search" },
                query: {
                  jobID: this.jobIDKanban,
                  cardName: this.customerNameKanban,
                  customerID: this.customerId,
                },
              },
              {
                name: "SearchCandidate",
                meta: { title: "...", breadcrumbTitle: "Search Candidate" },
              },
              {
                name: "BookmarkedCandidates",
                meta: {
                  title: "...",
                  breadcrumbTitle: "Bookmarked Candidates",
                },
              }
            );
          } else if (this.$route.query.from.endsWith("talentpool")) {
            matched.splice(0, 0, {
              name: "TalentPool",
              meta: { title: "TalentPool" },
            });
          } else if (this.$route.query.from == "kanban") {
            matched.splice(0, 0, {
              name: "Kanban",
              meta: { title: "Kanban" },
              query: {
                cardName: this.$route.query.cardName,
                itype: this.$route.query.itype,
                jobID: this.$route.query.jobID,
                customerID: this.$route.query.customerID,
              },
            });
          } else if (this.$route.query.from == "vendorkanban") {
            matched.splice(0, 0, {
              name: "VendorKanban",
              meta: { title: "Kanban" },
              params: {
                vendorID: this.$route.query.vendorID,
                client: this.$route.query.client,
              },
              query: {
                clientName: this.$route.query.clientName,
                jobTitle: this.$route.query.jobTitle,
                jobID: this.$route.query.jobID,
                vendorID: this.$route.query.vendorID,
              },
            });
          } else if (this.$route.query.from == "BotAnalysis") {
            if (this.$route.query.fromkanban) {
              matched.splice(
                0,
                0,
                {
                  name: "Kanban",
                  meta: { title: "Kanban" },
                  query: {
                    cardName: this.$route.query.cardName,
                    itype: this.$route.query.itype,
                    jobID: this.$route.query.jobID,
                    customerID: this.$route.query.customerID,
                  },
                },
                {
                  name: "BotAnalysis",
                  meta: { title: "Candidate Analysis" },
                  query: this.$route.query,
                }
              );
            } else {
              matched.splice(0, 0, {
                name: "BotAnalysis",
                meta: { title: "Candidate Analysis" },
                query: this.$route.query,
              });
            }
          } else {
            matched.splice(
              0,
              0,
              {
                name: this.currentComponentName,
                meta: { title: this.currentComponentTitle },
                query: {
                  jobID: this.jobIDKanban,
                  cardName: this.customerNameKanban,
                  customerID: this.customerId,
                },
              },
              {
                name: this.currentCvSearch,
                meta: { title: "CV Search" },
                query: {
                  jobID: this.jobIDKanban,
                  cardName: this.customerNameKanban,
                  customerID: this.customerId,
                },
              },
              {
                name: "SearchCandidate",
                meta: { title: "...", breadcrumbTitle: "Search Candidate" },
              }
            );
          }
          return matched;
        case "BotAnalysis":
          if (this.$route.query.fromkanban) {
            matched.splice(0, 1, {
              name: "Kanban",
              meta: { title: "Kanban" },
              query: {
                cardName: this.$route.query.cardName,
                itype: this.$route.query.itype,
                jobID: this.$route.query.jobID,
                customerID: this.$route.query.customerID,
              },
            });
          } else matched.splice(0, 1);
          return matched;
        case "BookmarkedCandidates":
          matched.splice(
            0,
            0,
            {
              name: this.currentComponentName,
              meta: { title: this.currentComponentTitle },
              query: {
                jobID: this.jobIDKanban,
                cardName: this.customerNameKanban,
                customerID: this.customerId,
              },
            },
            {
              name: this.currentCvSearch,
              meta: { title: "CV Search" },
              query: {
                jobID: this.jobIDKanban,
                cardName: this.customerNameKanban,
                customerID: this.customerId,
              },
            }
          );
          return matched;
        case "Feedbackform":
        case "EditFeedbackform":
          if (this.$route.query.status == "interview") {
            matched.splice(
              0,
              3,
              {
                name: "HiringProcessDashboard",
                meta: { title: "Hiring Process" },
                query: {
                  status: "interviewProcess",
                  type: this.$route.query.type,
                  sort: this.$route.query.sort,
                },
              },
              {
                name: "CreateInterviewProcess",
                meta: {
                  title: "...",
                  breadcrumbTitle: "Create Interview Process",
                },
                query: {
                  status: this.$route.query.status,
                  type: this.$route.query.type,
                  sort: this.$route.query.sort,
                },
              },
              {
                name: "Feedbackform",
                meta: { title: "Create Feedback Form" },
              }
            );
          } else if (this.$route.query.status == "editInterview") {
            matched.splice(
              0,
              3,
              {
                name: "HiringProcessDashboard",
                meta: { title: "Hiring Process" },
                query: {
                  status: "interviewProcess",
                  type: this.$route.query.type,
                  sort: this.$route.query.sort,
                },
              },
              {
                name: "EditInterviewProcess",
                meta: {
                  title: "...",
                  breadcrumbTitle: "Edit Interview Process",
                },
                query: {
                  type: this.$route.query.type,
                  sort: this.$route.query.sort,
                },
                params: {
                  interviewProcessID: this.$route.query.interviewProcessID,
                },
              },
              {
                name: "Feedbackform",
                meta: { title: "Create Feedback Form" },
              }
            );
          } else {
            matched.splice(0, 0, {
              status: this.$route.params.status_i || this.$route.query.status,
              name: "HiringProcessDashboard",
              meta: { title: "Hiring Process" },
              query: {
                status: this.$route.params.status_i || this.$route.query.status,
                type: this.$route.query.type,
                sort: this.$route.query.sort,
              },
            });
          }
          return matched;
        case "CustomerReport":
        case "RecruiterReport":
        case "PanelistReport":
        case "VendorReport":
          matched.splice(0, 0, {
            name: "ReportDashboard",
            meta: { title: "Reports" },
          });
          return matched;
        case "workBench":
          matched.splice(0, 1, {
            name: "workBench",
            meta: { title: "Customers" },
          });
          return matched;
        case "SearchCandidate":
          matched.splice(
            0,
            0,
            {
              name: this.currentComponentName,
              meta: { title: this.currentComponentTitle },
              query: {
                jobID: this.jobIDKanban,
                cardName: this.customerNameKanban,
                customerID: this.customerId,
              },
            },
            {
              name: this.currentCvSearch,
              meta: { title: "CV Search" },
              query: {
                jobID: this.jobIDKanban,
                cardName: this.customerNameKanban,
                customerID: this.customerId,
              },
            }
          );
          return matched;
        case "Bookmark":
          matched.splice(0, 0, {
            name: "TalentPool",
            meta: { title: "Talent Pool" },
          });
          return matched;
        default:
          return matched;
      }
    },
  },
  created() {
    this.getNotificationDataDetails();
    this.routename();
    this.getBreadcrumb();
    if (this.$route.name == "PanelDetails" && checkExternalPanelist()) {
      let email = getLoggedInUserEmail();
      this.$store.commit("userVUEX/saveUserEmail", email);
      this.getUsericon();
    }
    this.searchValue = "";
    console.log(this.$route.name);
    this.getCookieData();
    this.getPref();
    checkExternalPanelist() ? (this.external = true) : (this.external = false);
    EventBus.$on("clearTalentPoolFilters", this.clearTalentPoolFilters);
  },
  beforeDestroy() {
    EventBus.$off("clearTalentPoolFilters", this.clearTalentPoolFilters);
    window.removeEventListener("resize", this.updateAdvRowsScroll);
  },
  watch: {
    showAdvanceSearch(open) {
      if (open) this.$nextTick(this.updateAdvRowsScroll);
    },
    "advancedFilters.length"(len, oldLen) {
      this.$nextTick(() => {
        this.updateAdvRowsScroll();
        // Bring a newly added row into view when the rows area scrolls.
        const rows = this.$refs.advRows;
        if (len > oldLen && this.advRowsScroll && rows) {
          rows.scrollTop = rows.scrollHeight;
        }
      });
    },
    searchTab() {
      if (this.searchTab === "Teams") {
        this.sharePage = true;
      } else {
        this.sharePage = false;
        this.searchbar = this.searchTab;
      }
    },
    vendorValue() {
      if (this.vendorValue) {
        this.searchbar = "Vendor";
      } else {
        this.searchbar = "Customer";
      }
    },
    $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith("/redirect/")) {
        return;
      }
      if (this.$route.query?.advancedSearch === "search") {
        this.searchApplied = false;
      }
      this.searchValue = "";
      this.$store.commit("searchVUEX/saveSearchQuery", this.searchValue);
      this.routename();
      this.prefetchAdvancedSearchFields();
      this.getBreadcrumb();
      this.reset();
    },
  },
  components: {
    Select,
    MultiSelectCustom,
    InputField,
    SelectCustom,
    FormTags,
    DateField,
    Sourcemulti,
    AddedByUsers,
  },
  mounted() {
    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
    window.addEventListener("resize", this.updateAdvRowsScroll);
    this.prefetchAdvancedSearchFields();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    goToCredits() {
      // window.open("https://utility.simplifycv.com/login");
      window.open("https://utility.hire3x.com");
    },
    closeAccountsetting() {
      this.showAccountsettings = false;
    },
    closenotidd(groupName, index) {
      this.groupedNotifications[groupName][index].activeDropdownIndex = false;
    },
    togglemarkasreadDropdown(groupName, index) {
      this.groupedNotifications[groupName][index].activeDropdownIndex =
        !this.groupedNotifications[groupName][index].activeDropdownIndex;
    },
    goToEventLink(event) {
      if (event.linkType === "2") {
        window.open(event.link, "_blank");
      } else {
        const url = new URL(event.link, window.location.origin);

        this.$router.push({
          path: url.pathname,
          query: Object.fromEntries(url.searchParams),
        });
      }
      this.$refs.notiDropdown.hide(true);
      this.isnotiDropdownOpen = false;
      this.$forceUpdate();
    },
    onScroll(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        // Check if there is more data to load.
        console.log(
          this.checkbetween(this.pageEnd, 0, this.total),
          this.showLoader,
          "loader"
        );

        if (
          this.checkbetween(this.pageEnd, 0, this.total) &&
          !this.showLoader
        ) {
          this.showLoader = true;
          this.page++;

          this.getNotificationDataDetails();
        }
      }
    },
    checkbetween(x, min, max) {
      // Return `true` if `x` is between `min` and `max`, otherwise `false`.
      return x > min && x < max;
    },
    async makeasReadandUnread(item) {
      try {
        const payload = {
          userID: this.userInfo.userID,
          notificationIDs: [item.notificationID],
        };
        const response = await markasReadandUnreadNotification(payload);
        if (response.status == 200) {
          item.read = !item.read;
          item.activeDropdownIndex = false;
          this.getNotificationDataDetails();
        } else {
          this.errorModal("Something went wrong!");
        }
      } catch (error) {
        this.errorModal("Something went wrong!");
        console.log(error);
      }
    },
    async marknotificationAsRead() {
      try {
        const payload = {
          userID: this.userInfo.userID,
          markAllRead: true,
        };
        const response = await markasReadNotification(payload);
        if (response.status == 200) {
          this.successModal("All notifications are marked as read");
          this.getNotificationDataDetails();
        } else {
          this.errorModal("Something went wrong!");
        }
      } catch (error) {
        this.errorModal("Something went wrong!");
        console.log(error);
      }
    },
    async getNotificationDataDetails() {
      try {
        this.isLoading = true;
        // console.log("came here", this.userInfo.userID);
        const payload = {
          userID: this.userInfo.userID,
          count: 10,
          page: this.page,
          order: -1,
        };
        const res = await getNotificationData(payload);
        if (res.status == 200) {
          this.isLoading = false;
          if (this.page == 0) {
            this.notifications = res.data.data.data.map((n) => ({
              ...n,
              activeDropdownIndex: false,
            }));
          } else {
            const newItems = res.data.data.data.map((n) => ({
              ...n,
              activeDropdownIndex: false,
            }));
            this.notifications = [...this.notifications, ...newItems];
          }

          console.log(
            "notifications",
            this.notifications,
            "total",
            res.data.data.totalCount
          );

          this.total = res.data.data.totalCount;
          this.pageEnd = res.data.data.pageEnd;
          this.totalUnreadCount = res.data.data.totalUnreadCount;
          this.showLoader = false;
        }
      } catch (error) {
        this.isLoading = true;
        console.log(error);
      }
    },
    closAdvanceFilter() {
      this.showAdvanceSearch = false;
    },
    deleteFilter(index) {
      this.advancedFilters.splice(index, 1);
      this.filterCustomFieldsArray = this.customFieldsArray.filter(
        // (item) => !this.hobyNameList.includes(item.value)
        (item) => {
          return !this.advancedFilters.some((field) => field.key === item.key);
        }
      );
    },
    getDynamicName(route) {
      if (route.name == "cvSearchTalentPool") {
        this.currentComponentName = "TalentPool";
        this.currentCvSearch = "cvSearchTalentPool";
        this.jobIDKanban = null;
        this.customerNameKanban = null;
        return "TalentPool";
      } else if (route.name == "cvSearchKanban") {
        this.jobIDKanban = route.query.jobID;
        this.customerNameKanban = route.query.cardName;
        (this.customerId = route.query.customerID),
          (this.currentCvSearch = "cvSearchKanban");
        this.currentComponentName = "Kanban";
        return "Kanban";
      }
      return "na";
    },
    getDynamicTitle(route) {
      if (route.name == "cvSearchTalentPool") {
        this.currentComponentTitle = "Talent Pool";
        return "Talent Pool";
      } else if (route.name == "cvSearchKanban") {
        this.currentComponentTitle = "Kanban";
        return "Kanban";
      }
      return "na";
    },
    getComponentTitle(route) {
      if (route.name == "Kanban") {
        this.currentTitle = "Kanban";
        return "Kanban";
      } else if (route.name == "Analytics") {
        this.currentTitle = "Job Report";
        return "Job Report";
      }
      let title =
        route.meta.title || route.name.replace(/(?<=\p{Ll})(?=\p{Lu})/gu, " ");
      return title;
    },
    search() {
      this.$router.replace({ path: "/talentpool" });

      const isEmpty = (v) =>
        v === undefined ||
        v === null ||
        v === "" ||
        (Array.isArray(v) && v.length === 0);

      const newArray = this.advancedFilters
        .filter((obj) => obj.key !== undefined && !isEmpty(obj.value))
        .map((obj) => {
          // Virtual fields keep their plain key (mapped to existing filter
          // params in TalentPool); custom form fields are prefixed so the
          // backend queries the customFields sub-document.
          const key =
            !obj.virtual && obj.fieldType != "default"
              ? "customFields." + obj.key
              : obj.key;
          const row = {
            key,
            value: obj.value,
            operator: obj.operator || this.defaultOperator(obj),
            type: obj.controlType || "text",
          };
          if (obj.virtual) row.virtual = true;
          if (obj.controlType == "date") row.date = true;
          return row;
        });

      EventBus.$emit("applyAdvanceSearch", newArray);
      this.storeFilter = this.advancedFilters.concat();
      this.searchApplied = newArray.length > 0;
      this.showAdvanceSearch = false;
    },
    reset() {
      this.advancedFilters = [];
      // this.$nextTick(() => {
      this.advancedFilters = [
        {
          value: "",
        },
      ];
      // });

      if (this.searchApplied) {
        EventBus.$emit("applyAdvanceSearch", []);
        this.storeFilter = this.advancedFilters.concat();
        this.showAdvanceSearch = false;
      }
      this.searchApplied = false;
    },
    // Triggered by Talent Pool's "Clear filters" empty-state button: clear the
    // advanced-search rows, the applied indicator and the text box. Talent Pool
    // clears the search store and reloads the list once, so this does not emit.
    clearTalentPoolFilters() {
      this.advancedFilters = [{ value: "" }];
      // Keep one empty starter row (getCustomerFields restores from storeFilter
      // when the popover reopens), matching a normal reset.
      this.storeFilter = this.advancedFilters.concat();
      this.searchApplied = false;
      this.showAdvanceSearch = false;
      this.searchValue = "";
    },
    cancel() {
      this.showAdvanceSearch = false;
      this.advancedFilters = this.storeFilter.concat();
    },
    async getPref() {
      try {
        const res = await getPreference();
        if (res.status == 200) {
          this.preferences = res.data.data;
          this.selected = this.preferences.defaultModule;
          this.status = this.preferences.dontAskMeAgain;

          console.log(this.status);
          if (
            !this.status &&
            getShowPreference().showPreference &&
            this.$route.name != "PanelDetails"
          ) {
            // this.checkpref();
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async setPref() {
      console.log("in set pref");
      // this.$store.commit("userVUEX/setShowPref", true);
      try {
        let payload = {
          defaultModule: this.selected,
          dontAskMeAgain: this.status,
        };
        const res = await postPreference(payload);
        if (res.status == 200) {
          this.$bvModal.hide("preferencemodal");
          setShowPreference(getShowPreference());
          this.successModal("Preference updated successfully");
          this.getPref();
        }
      } catch (error) {
        console.log(error);
      }
    },
    checkpref() {
      if (this.count > 1) {
        this.$nextTick(() => {
          this.$bvModal.show("preferencemodal");
        });
      }
    },
    closeval() {
      // this.$store.commit("userVUEX/setShowPref", true);
      setShowPreference(getShowPreference());
      this.$bvModal.hide("preferencemodal");
      this.getPref();
    },
    closeLog() {
      this.showdpcard = false;
    },
    closeSwitch() {
      this.showswitch = false;
    },
    openAssess() {
      if (this.accessAssessment) {
        // location.replace("http://localhost:8081");
        window.open("https://judge.hire3x.com");
      }
    },
    openCan() {
      if (this.accessCandidate) {
        window.open("https://candidate.hire3x.com?from=candidate");
        // location.replace("http://localhost:8083");
      }
    },
    openTraining() {
      if (this.accessTraining) {
        // location.replace("http://localhost:8081");
        window.open("https://trainingadmin.hire3x.com?from=login");
      }
    },
    getCookieData() {
      let data = document.cookie.split(";");
      for (let i in data) {
        let token = data[i].split("=")[0];
        if (token.trim() === "assessment") {
          this.accessAssessment = data[i].split("=")[1] !== "no-access";
          this.accessAssessment ? this.count++ : "";
        }
        if (token.trim() === "training") {
          this.accessTraining = data[i].split("=")[1] !== "no-access";
          this.accessTraining ? this.count++ : "";
        }
        if (token.trim() === "candidate") {
          this.accessCandidate = data[i].split("=")[1] !== "no-access";
          this.accessCandidate ? this.count++ : "";
        }
      }
    },
    checkScreenSize() {
      this.isLaptop = window.innerWidth >= 1024;
    },
    // MAKE THE SIDE BAR WIDTH FIXED
    expandSideBar() {
      this.$store.commit("userVUEX/setMenuStatus", true);
    },
    // CLOSE THE FIXED SIDEBAR
    closeSideBar() {
      this.$store.commit("userVUEX/setMenuStatus", false);
    },

    handleHover(hovered) {
      this.showdpcard = hovered;
    },
    searchRec() {
      this.$store.commit("searchVUEX/saveSearchQuery", this.searchValue);
    },
    textSearch() {
      this.$store.commit("searchVUEX/saveSearchQuery", "Loader");
      this.$store.commit("searchVUEX/saveSearchQuery", this.searchValue);
    },
    getBreadcrumb() {
      this.levelList = this.switchBreadcrumbs.filter(
        (item) => item.meta?.title && item.meta.breadcrumb !== false
      );

      this.levelList[this.levelList.length - 1].active = true;
    },

    pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const { params } = this.$route;
      const toPath = compile(path);
      return toPath(params);
    },
    handleLink(item) {
      const { redirect, path, name, query } = item;
      if (redirect) {
        this.$router.push(redirect);
        return;
      }
      if (name) {
        this.$router.push({
          name: name,
          params: item.params,
          query: query,
        });
        return;
      }
      if (query) {
        this.$router.push({
          path: path,
          query: query,
        });
        return;
      }
      this.$router.push(this.pathCompile(path));
    },
    logout() {
      localStorage.clear();
      this.$store.dispatch("userVUEX/LogOut");

      // location.replace("https://hire3x.com/login?from=recruitment");
    },

    onClickLogOut() {
      this.$keycloakvar.logout();
      localStorage.clear();
      this.$store.commit("accessControlVUEX/saveRoleValuesData", {});
      this.$store.commit("customerVUEX/saveAllCustomer", []);
      this.$store.commit("panelVUEX/saveAllPanel", []);
      this.$store.commit("addVendorVUEX/saveAllVendor", []);
      this.$store.commit("jobDescriptionVUEX/saveAllJobDesc", []);
      this.$store.commit("scheduleInterviewVUEX/saveInterview", []);
      this.$store.commit("userVUEX/getRoleValue", {});
      this.$store.commit("userVUEX/saveUserData", {});
      this.$store.commit("userVUEX/saveLicenseKey", "");

      location.reload();
    },
    regfn() {
      this.$keycloakvar.register({ action: "register" });
    },
    forcelogin() {
      this.$keycloakvar.login();
    },
    routename() {
      const routeName = this.$route.name;
      console.log("the routeme", routeName);
      switch (routeName) {
        case "workBench":
          this.route = "Workbench";
          this.searchbar = "Customer";
          this.sharePage = false;
          break;
        case "SearchCandidate":
          this.sharePage = false;
          this.searchbar = "Candidates";
          break;
        case "PanelLogin":
          this.sharePage = false;
          this.searchbar = "Candidates";
          break;
        case "vendorDashboard":
        case "InternalHiringDashboard":
          this.searchbar = "Jobs";
          this.sharePage = false;
          this.route = this.$route.params.cardName;
          break;
        case "Manage":
          if (this.vendorValue && this.$route.query.status == "manage") {
            this.searchbar = "Vendor";
          } else {
            this.searchbar = "Customer";
          }
          this.sharePage = false;
          this.route = "Manage Dashboard";
          break;
        case "CreateJob":
          this.route = this.$route.query.cardName;
          this.sharePage = true;
          break;
        case "EditJobs":
          this.route = this.$route.query.cardName;
          this.sharePage = true;
          break;
        case "AddCustomer":
          this.sharePage = true;
          this.route = "Add Customer";
          break;

        case "EditCustomer":
          this.sharePage = true;
          this.route = "Edit Customer";
          break;

        case "EditVendor":
          this.sharePage = true;
          this.route = "Edit vendor";
          break;

        case "Panellist":
          this.sharePage = false;
          this.route = "Panel List";
          this.searchbar = "Panelist";
          break;

        case "vendorCandidates":
          this.sharePage = true;
          this.route = "Vendor Candidate";
          break;

        case "AddPanel":
          this.sharePage = true;
          this.route = "Add Panel List";
          break;

        case "EditPanel":
          this.sharePage = true;
          this.route = "Edit Panel List";
          break;

        case "GiveFeedback":
          this.sharePage = true;
          this.route = "Resume Screening";
          break;

        case "AccessControl":
          this.sharePage = false;
          this.route = "User Management";
          this.searchbar = this.searchTab;
          break;

        case "TalentPool":
          this.sharePage = false;
          this.route = "Talent Pool";
          this.searchbar = "Candidates";
          break;

        case "AddCandidate":
          this.sharePage = true;
          this.route = "Add Candidate";
          break;

        case "EditCandidate":
          this.sharePage = true;
          this.route = "Edit Candidate";
          break;
        case "ActivateCandidate":
          this.sharePage = true;
          this.route = "Activate Candidate";
          break;

        case "ReportDashboard":
          this.sharePage = true;
          this.route = "Reports";
          break;

        case "HiringProcessDashboard":
          if (this.$route.query.status == "interviewProcess") {
            this.searchbar = "Interview Process";
          } else {
            this.searchbar = "Feedback Form";
          }
          this.sharePage = false;
          this.route = "Interview Process";
          break;

        case "CreateInterviewProcess":
          this.sharePage = true;
          this.route = "Create Interview Process";
          break;

        case "EditInterviewProcess":
          this.sharePage = true;
          this.route = "Edit Interview Process";
          break;

        case "Dashboard":
          this.sharePage = true;
          this.route = "HR Portal";
          break;

        case "PreviewFeedbackform Dashboard":
          this.sharePage = false;
          this.searchbar = "Feedback Form";
          this.route = "Feedback";
          break;

        case "Feedbackform":
          this.sharePage = true;
          this.route = "Add Feedback";
          break;

        case "JdDetails":
        case "Kanban":
          this.searchbar = "Candidates";
          this.sharePage = false;
          this.route = this.$route.query.jobTitle;
          break;

        case "JobDashboard":
          this.searchbar =
            this.$route.query.status === "recruiterview"
              ? "Allocated Recruiters"
              : "Assigned Jobs";
          this.sharePage = false;
          break;

        case "Documents":
          this.sharePage = true;
          this.route = "Documents";
          break;

        case "ViewJds":
          this.searchbar = "Jobs";
          this.sharePage = false;
          this.route = "View JD's";
          break;

        case "ReviewCandidates":
          this.searchbar = "Candidates";
          this.sharePage = false;
          this.route = "View Candidates";
          break;

        case "cvSearchKanban":
        case "cvSearchTalentPool":
          this.searchbar = "Saved Searches";
          this.sharePage = false;
          this.route = "Saved Searches";
          break;

        case "BookmarkedCandidates":
          this.searchbar = "Bookmarked Candidates";
          this.sharePage = false;
          this.route = "Bookmarked Candidates";
          break;

        case "ViewCandidateProfile":
          this.sharePage = true;
          this.route = "View Candidate Profile";
          break;

        case "AddFromThirdParty":
          this.sharePage = true;
          this.route = "Add From Third Party";
          break;

        case "jobs":
          this.searchbar = "Jobs";
          this.sharePage = false;
          this.route = "jobs";
          break;

        case "VendorKanban":
          this.searchbar = "Candidates";
          this.sharePage = false;
          this.route = "VendorKanban";
          break;

        case "clientdashboard":
          this.searchbar = "Clients";
          this.sharePage = false;
          this.route = "clientdashboard";
          break;

        case "Bookmark":
          this.searchbar = "in Bookmarks";
          this.sharePage = false;
          this.route = "Bookmark";
          break;

        default:
          if (["JobRegistration", "FareWellPage"].includes(routeName)) {
            this.display = false;
            this.sharePage = true;
          } else if (
            [
              "AddVendor",
              "Profile",
              "AddCandidateInJD",
              "AddCandidateInVendor",
              "SelectedCandidates",
              "SendAppointment",
              "OnboardingCandidates",
              "RejectedCandidates",
              "CandidateDetails",
              "GiveFeedBackForm",
              "ViewCandidateStatus",
              "ViewOnboardingCandidate",
              "EditOfferLetter",
              "OfferLetter",
              "ApplicationTable",
              "ApplicationPreview",
              "EditCandidateInJD",
              "EditCandidateInVendor",
              "viewRequiredCandidateDocs",
              "Teams",
              "PanelLogin",
              "EditOfferLetter",
              "TemplatesOfferLetter",
              "404",
              "ActivateCustomer",
              "ActivateVendor",
              "MainDashboard",
              "Uploaddocuments",
              "ActivateInterview",
              "ViewInterviewProcess",
              "cvSearch",
              "PanelDetails",
              "ActivateFeedbackForm",
              "EditFeedbackform",
              "Feedbackform Dashboard",
              "customform",
              "customtable",
              "Analytics",
              "ViewCandidateProfile",
              "PreviewOpsheadCandidateProfile",
              "PanelistReport",
              "VendorReport",
              "RecruiterReport",
              "CustomerReport",
              "OnboardingDocuments",
              "Transactions",
              "BotAnalysis",
            ].includes(routeName)
          ) {
            this.sharePage = true;
          }
          break;
      }
      // Any other common logic or actions that should follow regardless of the route
    },
    // Opens Advanced Search from the cached form config; the first open waits
    // for the fetch only if the prefetch hasn't finished. The config is
    // fetched once per page load.
    async getCustomerFields() {
      if (this.showAdvanceSearch) {
        this.showAdvanceSearch = false;
        return;
      }
      this.advancedFilters = this.storeFilter.concat();
      if (!this.advFormFields) await this.loadAdvancedSearchFields();
      if (!this.advFormFields) return;
      this.buildAdvancedSearchFields(this.advFormFields);
      this.showAdvanceSearch = true;
    },
    prefetchAdvancedSearchFields() {
      if (this.$route.name === "TalentPool" && !this.advFormFields) {
        this.loadAdvancedSearchFields();
      }
    },
    // Fetches the candidate form config (parentID 5) and caches it; concurrent
    // calls share one request. Resolves to the fields, or null on failure.
    loadAdvancedSearchFields() {
      if (!this.advFormFieldsRequest) {
        this.advFormFieldsRequest = getCustomerFields({ parentID: 5 })
          .then((res) => {
            if (res.status == 200) this.advFormFields = res.data.data.fields;
            return this.advFormFields;
          })
          .catch((error) => {
            console.error(error);
            return null;
          })
          .finally(() => {
            this.advFormFieldsRequest = null;
          });
      }
      return this.advFormFieldsRequest;
    },
    buildAdvancedSearchFields(allFields) {
      const virtualFields = this.getVirtualFilterFields();
      const virtualKeys = new Set(virtualFields.map((f) => f.key));
      // `hide` also marks conditional child fields (e.g. "Others (In
      // days)" under Notice Period); those are real candidate data, so
      // keep them. "default" children (Other Source) are covered by the
      // virtual Source filter.
      const formFields = allFields
        .filter(
          (data) =>
            data.search === true &&
            (data.hide == false ||
              (data.parentKey && data.fieldType !== "default")) &&
            !virtualKeys.has(data.key)
        )
        .map((data) => ({
          ...data,
          label: fieldDisplayLabel(data, allFields),
        }));
      // Unified filter list: the table/common filters (virtual) and every
      // searchable form field, alphabetical so the list is easy to scan.
      this.customFieldsArray = [...virtualFields, ...formFields].sort((a, b) =>
        String(a.label).localeCompare(String(b.label), undefined, {
          sensitivity: "base",
        })
      );
      this.filterCustomFieldsArray = this.customFieldsArray;
    },
    addNewField() {
      this.advancedFilters.push({
        value: "",
      });
    },
    // Switch the filter rows to a scroll area only once they would push the
    // popover past the viewport; below that they stay unclipped so every
    // row's dropdown menu can extend over the footer.
    updateAdvRowsScroll() {
      const rows = this.$refs.advRows;
      const card = this.$refs["advance-filter-card"];
      if (!rows || !card || !rows.firstElementChild) {
        this.advRowsScroll = false;
        return;
      }
      // Rows' own extent — independent of the current scroll position.
      const natural =
        rows.lastElementChild.getBoundingClientRect().bottom -
        rows.firstElementChild.getBoundingClientRect().top;
      const cardRect = card.getBoundingClientRect();
      // Title, footer buttons and padding around the rows area.
      const chrome = cardRect.height - rows.getBoundingClientRect().height;
      // Keep room under the card so the last row's dropdown menu (~135px,
      // overlapping the footer) still ends inside the viewport.
      const menuReserve = 70;
      const available = Math.floor(
        window.innerHeight - cardRect.top - chrome - menuReserve
      );
      this.advRowsMaxHeight = Math.max(230, available);
      this.advRowsScroll = natural > this.advRowsMaxHeight;
    },
    // When the rows area scrolls, a dropdown opened near its bottom edge would
    // be clipped; scroll just enough to reveal the menu that the click opened
    // (Select / multi-select / tags menus are absolutely positioned).
    revealAdvRowPopup(event) {
      const rows = this.$refs.advRows;
      const row = event.target.closest && event.target.closest(".tp-adv-frow");
      if (!this.advRowsScroll || !rows || !row) return;
      // The menu renders after the trigger's own click handler re-renders.
      setTimeout(() => {
        const view = rows.getBoundingClientRect();
        const rowTop = row.getBoundingClientRect().top;
        let bottom = 0;
        row.querySelectorAll("*").forEach((el) => {
          if (el.offsetHeight && getComputedStyle(el).position === "absolute") {
            bottom = Math.max(bottom, el.getBoundingClientRect().bottom);
          }
        });
        const overflow = bottom - view.bottom + 4;
        if (overflow > 0) {
          // Never scroll the clicked row's own inputs out of view.
          rows.scrollTop += Math.min(overflow, Math.max(0, rowTop - view.top));
        }
      }, 60);
    },
    // Phone-like fields are configured as controlType "number" but hold
    // identifiers, not quantities, so numeric comparisons make no sense.
    isPhoneField(field) {
      if (!field || field.virtual) return false;
      const text = `${field.key || ""} ${field.label || ""}`;
      return /phone|mobile|whatsapp|contact\s*(no|num)|alternate\s*number/i.test(
        text
      );
    },
    // Common table filters exposed in the unified advanced search alongside the
    // form fields. They map (in TalentPool) onto the existing backend filter
    // params rather than the generic advancedFilters matcher.
    getVirtualFilterFields() {
      const isVendor =
        this.roles && this.roles.includes("GET_VENDOR_DASHBOARD");
      const fields = [
        {
          key: "skills",
          label: "Skills",
          controlType: "multi_text",
          fieldType: "default",
          virtual: true,
        },
        {
          key: "cvsStatus",
          label: "CVS Status",
          controlType: "static_multi_select",
          fieldType: "default",
          virtual: true,
          dropdown: true,
          values: [
            { key: "1", label: "Triggered" },
            { key: "0", label: "Not Triggered" },
            { key: "2", label: "Submitted" },
          ],
        },
        {
          key: "source",
          label: "Source",
          controlType: "source",
          fieldType: "default",
          virtual: true,
        },
        {
          key: "updatedAt",
          label: "Updated At",
          controlType: "date",
          fieldType: "default",
          dateTimeFormat: "YYYY-MM-DD",
          virtual: true,
        },
        {
          key: "createdAt",
          label: "Created At",
          controlType: "date",
          fieldType: "default",
          dateTimeFormat: "YYYY-MM-DD",
          virtual: true,
        },
        {
          key: "status",
          label: "Status",
          controlType: "static_select",
          fieldType: "default",
          virtual: true,
          options: [
            { value: "1", text: "Active" },
            { value: "0", text: "Inactive" },
          ],
        },
      ];
      if (!isVendor) {
        fields.splice(3, 0, {
          key: "addedBy",
          label: "Added By",
          controlType: "addedBy",
          fieldType: "default",
          virtual: true,
        });
      }
      // Vendors can't trigger CVS, so they get no CVS Status filter.
      return isVendor ? fields.filter((f) => f.key !== "cvsStatus") : fields;
    },
    // Type-driven operator choices.
    operatorOptions(field) {
      const t = field && field.controlType;
      const multiOps = [
        { value: "includes_any", text: "Includes any" },
        { value: "includes_all", text: "Includes all" },
        { value: "not_includes", text: "Does not include" },
      ];
      // "After"/"Before" reuse the numeric greater/less operator codes so the
      // backend shares one comparison path; "Between" keeps the range picker.
      const dateOps = [
        { value: "between", text: "Between" },
        { value: "greater_than", text: "After" },
        { value: "less_than", text: "Before" },
      ];
      const isNotOps = [
        { value: "is", text: "Is" },
        { value: "is_not", text: "Is not" },
      ];
      // Virtual (common) filters reuse the dedicated backend filter params, so
      // they only expose the operators those params actually honour.
      if (field && field.virtual) {
        // Created/Updated At honour After/Before via the start/end date params.
        if (t === "date") return dateOps;
        // Skills flows through the operator-aware advancedFilters matcher.
        if (t === "multi_text") return multiOps;
        // CVS Status is filtered via its dedicated $in/$nin filter.
        if (t === "static_multi_select") return isNotOps;
        // Source / Added By reuse legacy "match any" params — one operator only.
        if (t === "source" || t === "addedBy") {
          return [{ value: "includes_any", text: "Includes any" }];
        }
        return [{ value: "is", text: "Is" }];
      }
      // Boolean is two-valued, so "Is Yes" / "Is No" already covers both cases
      // — a separate "Is not" would be redundant.
      if (t === "boolean") {
        return [{ value: "is", text: "Is" }];
      }
      if (t === "single_select" || t === "static_select") {
        // A two-option select (e.g. a Yes/No field) is fully covered by "Is"
        // on either value, so "Is not" is redundant there too. Only expose it
        // when we can see the field has 3+ options (inline dropdowns);
        // API-loaded options are an unknown count, so keep both to be safe.
        const optCount =
          (field.values && field.values.length) ||
          (field.options && field.options.length) ||
          0;
        if (optCount === 2) return [{ value: "is", text: "Is" }];
        return isNotOps;
      }
      if (
        t === "multi_select" ||
        t === "multi_text" ||
        t === "source" ||
        t === "addedBy"
      ) {
        return multiOps;
      }
      if (t === "date") {
        return dateOps;
      }
      // Phone numbers (stored as strings) match as text: substring or exact.
      if (t === "number" && this.isPhoneField(field)) {
        return [
          { value: "contains", text: "Contains" },
          { value: "is", text: "Is" },
        ];
      }
      if (t === "number") {
        return [
          { value: "equals", text: "Equals" },
          { value: "greater_than", text: "Greater than" },
          { value: "less_than", text: "Less than" },
        ];
      }
      return [
        { value: "contains", text: "Contains" },
        { value: "is", text: "Is" },
      ];
    },
    defaultOperator(field) {
      const opts = this.operatorOptions(field);
      return opts.length ? opts[0].value : "contains";
    },
    setFieldKey(index, data) {
      const row = { ...data };
      row.value = "";
      row.operator = this.defaultOperator(data);
      this.$set(this.advancedFilters, index, row);
      this.filterCustomFieldsArray = this.customFieldsArray.filter((item) => {
        return !this.advancedFilters.some((field) => field.key === item.key);
      });
      this.$forceUpdate();
    },
    setFieldOperator(index, data) {
      const row = this.advancedFilters[index];
      // Date's value shape differs by operator (range array for "between",
      // single string for After/Before), so clear it when toggling between them.
      if (
        row.controlType === "date" &&
        (row.operator === "between") !== (data === "between")
      ) {
        row.value = "";
      }
      row.operator = data;
      this.$forceUpdate();
    },
    setFieldValue(index, data) {
      this.advancedFilters[index].value = data;
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.current-proj {
  border: 1px solid rgba(76, 120, 206, 0.5) !important;
  background: #e0eaff;
}
/* switch apps design */
.sp-main-container {
  border-radius: 8px;
  background: #e0eaff;
  padding: 4px;
}
.sp-license-container {
  position: absolute;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.03),
    0px 20px 24px -4px rgba(16, 24, 40, 0.08);
  padding: 16px;
  transform: translateX(-150px);
}
.sp-project-box {
  border-radius: 8px;
  border: 1px solid rgba(128, 128, 128, 0.16);
  display: flex;
  width: 81px;
  height: 68px;
  padding: 18px 24px 18px 25px;
  justify-content: center;
  align-items: center;
}
.sp-headings {
  color: #424242;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 500;
}
.sp-subheadings {
  color: #667085;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 400;
}
.sp-active-main-container {
  background: #f6f9fb;
  padding: 6px;
  border-radius: 8px;
}
.logout-txt {
  font-weight: 400;
  font-size: 12px;
  color: #696969;
}
.disable-dropdown-options {
  background: #ffffff;
  border: 1.26537px solid #f6f6f6;
  box-shadow: 0px 2px 10px rgba(196, 196, 196, 0.1);
  font-weight: 500;
  font-size: 14px;
  font-family: "Poppins", sans-serif;
  color: #c4c4c4;
}
.dropdown-options:hover {
  background: #f9f9f9;
  border: 1.26537px solid #f6f6f6;
  box-shadow: 0px 2px 10px rgba(196, 196, 196, 0.1);
}
.dropdown-options {
  background: #ffffff;
  border: 1.26537px solid #f6f6f6;
  box-shadow: 0px 2px 10px rgba(196, 196, 196, 0.1);
  font-weight: 500;
  font-size: 14px;
  font-family: "Poppins", sans-serif;
  color: #72738e;
}
.dropdown-active {
  background: #ededed;
  border: 1.26537px solid #f6f6f6;
  box-shadow: 0px 2px 10px rgba(196, 196, 196, 0.1);
  font-weight: 500;
  font-size: 14px;
  font-family: "Poppins", sans-serif;
  color: #72738e;
}
.dropdown-sub {
  background: #f9f9f9;
  border: 1.26537px solid #f6f6f6;
  box-shadow: 0px 2px 10px rgba(196, 196, 196, 0.1);
  border-radius: 10px 10px 0px 0px;
}
.dropdown-second {
  background: #f9f9f9;
  border: 1.26537px solid #f6f6f6;
  box-shadow: 0px 2px 10px rgba(196, 196, 196, 0.1);
}
.dropdown-head {
  color: #72738e;
  font-weight: 600;
  font-size: 14px;
}
.logoutbox {
  position: absolute;
  z-index: 7;
  width: 100%;
  right: 0;
  top: 45px;
  padding: 2px;
  background: #ffffff;
  box-shadow: 0px 5.06149px 25.3074px rgba(196, 196, 196, 0.5);
  border-radius: 10px;
}
.username {
  font-weight: 700;
  font-size: 12px;
  color: #72738e;
}
.welcometext {
  font-weight: 400;
  font-size: 12px;
  color: #72738e;
}
.login-det-container {
  background: #ffffff;
  border: 1px solid #f4f4f4;
  border-radius: 9px;
  padding: 10px;
}
a:hover {
  text-decoration: none !important;
}
</style>

<style>
#switchapp-popover .popover-body {
  padding: 0px !important;
}
/* Advanced-search filter row: three equal-width inputs (Field / Operator /
   Value) plus a trailing delete, all the same height and each with one
   consistent label — so nothing shifts when the field type changes. */
.tp-adv-frow {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
}
.tp-adv-fcell {
  flex: 1 1 0;
  min-width: 0;
}
/* Long selected labels (e.g. "Notice Period: Others (In days)") stay on one
   line with an ellipsis instead of wrapping and growing the row. */
.tp-adv-fcell .laptopinput > span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tp-adv-del-cell {
  flex: 0 0 auto;
}
.tp-adv-del-inner {
  height: 40px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Each value widget's own label is suppressed via its `noLabel` prop, so the
   single "Value" heading is the only label and the row can't shift when the
   field type changes. (No CSS label-hiding — that also hid the dropdown option
   labels inside the Source / Added By pickers.) */

/* Uniform input height across every widget type used in the value column.
   box-sizing keeps the forced height from clipping padded inputs. The three
   .tp-adv-val-scoped selectors cover SelectCustom/MultiSelectCustom
   (.selectCustom-field), AddedByUsers (.tp-dropdown-diffy) and FormTags. */
.advance-search-card .laptopinput,
.advance-search-card .teams-inputField,
.advance-search-card .mx-input,
.advance-search-card .datefield-input .mx-input,
.advance-search-card .tp-adv-val .selectCustom-field,
.advance-search-card .tp-adv-val .tp-dropdown-diffy,
.advance-search-card .tp-adv-val .customised-form-tags .form-control {
  height: 40px !important;
  box-sizing: border-box !important;
}
/* Source.vue / AddedByUsers.vue add mt-3 to their root .topDiv when no id is
   passed; reset it inside the value cell so every widget top-aligns. */
.advance-search-card .tp-adv-val .topDiv {
  margin-top: 0 !important;
}
/* Give the value widget the same 4px (mt-1) gap under the "Value" heading that
   the Field/Operator <Select> inputs have under their labels, so all three line
   up. Targets the single rendered widget wrapper (the direct child that isn't
   the heading); the higher specificity + !important beats the .topDiv reset
   above for that wrapper, while nested component-root .topDivs stay at 0. */
.advance-search-card .tp-adv-val > div:not(.acs-input-head) {
  margin-top: 0.25rem !important;
}

/* Rows area once it overflows the viewport (max-height set inline). */
.advance-search-card .tp-adv-rows-scroll {
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 15px;
  padding-bottom: 3px;
}

.disable-opacity {
  opacity: 0.5;
}

.breadcrumb-ellipsis {
  width: 50px !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  overflow: hidden !important;
}

.breadcrumb-ellipsis2 {
  max-width: 220px !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  overflow: hidden !important;
}

.search-bar .search-input {
  height: 35px;
  background: #72738e14;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 0 30px !important;
  width: 100%;
  border: none;
}

.search-bar .search-input:focus {
  background: #72738e14;
}

.search-bar .search-input::placeholder {
  color: #72738e80;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 400;
}

.search-pos {
  position: absolute;
  top: 11px;
  left: 8px;
}

.advance-pos {
  position: absolute;
  top: 6px;
  right: 6px;
  border-radius: 4px;
  box-shadow: 0px 0px 4px 0px #0000001a;
}

.breadcrumb-item + .breadcrumb-item:before {
  float: left;
  padding-right: 0.5rem;
  color: #6c757d;
  content: ">" !important;
}

.no-redirect {
  color: #97a8be;
  cursor: text;
}

.search-input[type="search"]::-webkit-search-cancel-button {
  cursor: pointer;
}
.prefmodal-btns .btn-light {
  border-radius: 4px;
  border: 1px solid var(--gray-300, #d0d5dd);
  color: var(--gray-900, #101828);
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
}
.prefmodal-btns .btn-primary {
  border-radius: 4px;
  background: #4c78ce;
  color: #fff;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
}
.prefmodal-checkbox .custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
  color: var(--gray-700, #344054);
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}
.prefmodal-checkbox .custom-control-label::before {
  border-radius: 2px;
  border: 1px solid var(--gray-300, #d0d5dd);
  background: var(--White, #fff);
}

.prefmodal-radios .custom-control {
  margin-top: 10px;
}
.prefmodal-radios .custom-control-label::before {
  border-radius: 10px;
  border: 1px solid var(--gray-300, #d0d5dd);
  background: var(--White, #fff);
}
.prefmodal-radios .custom-control-label::after {
  top: 2px;
}
.prefmodal-radios .custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
  color: var(--gray-700, #344054);
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
}
.prefmodalheading {
  color: var(--gray-900, #101828);
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 500;
}
.prefmodal-subhead {
  color: var(--gray-500, #667085);
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 400;
}
.header-profile-pic {
  border-radius: 50%;
  height: 43px;
  width: 43px;
}

.tnt-new-sortcard {
  background: var(--bg-white);
  box-sizing: border-box;
  box-shadow: 0px 1px 4px rgb(0 0 0 / 25%);
  border-radius: 5px;
  padding: 5px 15px;
  position: absolute;
  z-index: 7;
  font-size: var(--size-13);
  color: #545454;
  width: 250px;
  top: 35px;
  right: 0px;
}

.profile-container {
  background: #20639b;
  border-radius: 5px;
  padding: 5px;
}

.profile-container-font {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  font-family: "Lato", sans-serif;
}

.profile-container-img {
  border-radius: 50%;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  height: 30px;
  width: 30px;
  border: 2.5px solid #fff;
}

.profile-container-back {
  border-radius: 50%;
  border: 2.5px solid #fff;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 500;
  color: #fff;
}

.profile-container-subhead {
  color: #3a3c40;
  font-size: 14px;
  font-weight: 500;
  font-family: "Lato", sans-serif;
}

.sign-out-font {
  color: #20639b;
  font-size: 14px;
  font-weight: 500;
  font-family: "Lato", sans-serif;
}

.hoverclass:hover {
  background: #e8eff4;
  padding: 0.25rem !important;
}

.new-profile-line {
  border-bottom: 1px solid #cdc9c9;
}

.allproj-dropdown {
  position: absolute;
  right: 0;
  top: 42px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  padding: 16px;
  gap: 16px;
  background: #f6f9fb;
  border-width: 0px 1px 1px 1px;
  border-style: solid;
  border-color: #f6f9fb;
  box-shadow: 0px 83px 33px rgba(0, 0, 0, 0.01),
    0px 47px 28px rgba(0, 0, 0, 0.05), 0px 21px 21px rgba(0, 0, 0, 0.09),
    0px 5px 11px rgba(0, 0, 0, 0.1);
  border-radius: 16px 0px 16px 16px;
  width: 355px;
}

.allproj-card {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 12px;
  gap: 8px;
  height: 136px;
  width: 148px;
  background: #ffffff;
  cursor: pointer;
  border: 1px solid rgba(224, 224, 224, 0.5);
  border-radius: 8px;
}

.allproj-card:hover {
  border: 1px solid #20639b;
}
.allproj-card-selected {
  background: #deecf6 !important;
  border: 1px solid #20639b !important;
}
.allproj-card-selected img {
  background: #fff !important;
  border-radius: 50% !important;
}

.allproj-card-head {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.03em;
  color: #20639b;
  backdrop-filter: blur(2px);
}

.allproj-card:hover .allproj-card-head {
  color: #20639b;
}

.allproj-card-subhead {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #333333;
}

.notifications-dropdown {
  width: 450px;
  max-height: 595px;
  overflow-y: auto;
}
.notificationdd .dropdown-header {
  padding: 0.75rem 1rem !important;
  border-bottom: 1px solid #dee2e6;
}
.unread {
  background-color: #e8eff4;
  border-radius: 5px;
}
.unread:hover {
  background: #c8dceb !important;
  border-radius: 5px;
}
.notification-active-class {
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  border-radius: 4px;
}
.notificationdd .dropdown-menu {
  background-color: #ffffff;
  box-shadow: 0px 4px 34px rgba(196, 196, 196, 0.9);
  border-radius: 8px;
  border: unset;
  z-index: 20;
}
.markallread {
  font-family: "Lato";
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  color: #7a7a7a;
}
.notihighlight {
  color: #20639b;
  font-weight: 600;
}
.notiitems:hover {
  background: linear-gradient(0deg, #f6f6f6, #f6f6f6), #e8eff4;
  border-radius: 5px;
}
.notification-hr {
  border-top: 1px solid #dddddd;
  opacity: unset;
}
.notification-markasread-dd {
  width: 189px;
  height: 31px;
  background: #ffffff;
  border-radius: 4px;
  filter: drop-shadow(0px 8px 15px rgba(0, 0, 0, 0.4));
  position: absolute;
  right: 0;
  top: 15px;
}
.notification-markasread-dd:hover {
  background: #e8eff4;
}
.gap10px {
  gap: 10px;
}
.gap5px {
  gap: 5px;
}
.font-normal {
  font-style: normal;
}
.profilepic-border {
  border-radius: 50%;
  border: 2.5px solid #fff;
  height: 43px;
  width: 43px;
}

.profilepic-border:hover {
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.profilepic-border-active {
  border-radius: 50%;
  border: 2.5px solid #fff;
  height: 43px;
  width: 43px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}
.notification-count-tag {
  background: #ad1927;
  border-radius: 100px;
  position: absolute;
  top: 4px;
  width: fit-content;
  padding: 0 5px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rightn7px {
  right: -7px;
}
.rightn12px {
  right: -12px;
}
.r0 {
  right: 0px;
}
</style>
